import { ISelectCustomersHook } from '@models';
import { useStore } from '@stores';
import { debounce } from 'lodash';
import { useEffect, useState } from 'react';

export const useSelectCustomers = (): ISelectCustomersHook => {
  const { customerStore } = useStore();
  const { selectCustomers, selectLoading, selectSkipCount, selectPageSize } = customerStore;
  const [keyword, setKeyword] = useState<string>();

  useEffect(() => {
    keyword &&
      customerStore.getSelectCustomers({
        keyword,
        maxResultCount: selectPageSize,
        skipCount: selectSkipCount,
      });

    return () => customerStore.clearSelectCustomers();
  }, [customerStore, keyword, selectSkipCount, selectPageSize]);

  const handleSearch = debounce((text: string | undefined) => {
    setKeyword(text);
  }, 500);

  return {
    customers: Array.from(selectCustomers.values()),
    loading: selectLoading,
    handleSearch,
  };
};
